import {userConstants} from '../../_constants';

export function searchByArticleOwn(state = {}, action) {
  switch (action.type) {
    case userConstants.SEARCH_BY_ARTICLE_OWN_REQUEST:
      return {
        loading: true,
      };
    case userConstants.SEARCH_BY_ARTICLE_OWN_SUCCESS:
      return {
        ...action.data,
      };
    case userConstants.SEARCH_BY_ARTICLE_OWN_FAILURE:
      return {
        error: action.error,
      };
    case userConstants.RESET_SEARCH_RESULTS:
      return {};

    default:
      return state;
  }
}
